import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; 
import { FormControl, FormGroup } from '@angular/forms';
import { SubmissionService } from '../_services/submission.service';
import { BuildingService } from 'app/_services/building.service';
import { ClientService } from 'app/_services/client.service';
import { TokenStorageService } from '../_services/token-storage.service';
import flatpickr from "flatpickr";

@Component({
  selector: 'app-submissions',
  templateUrl: './add-submission.component.html',
  styleUrls: ['./submissions.component.scss']
})
export class AddSubmissionComponent implements OnInit {
  roofTypesList: any = [];
  roofAccessList: any = [];
  buildingTypesList: any = [];
  client_id: number = 0;
  clientInfo: any = [];
  contactTypeList: any = [];
  update_message: string = "";

  addSubmissionForm: FormGroup = new FormGroup({
    //client related
    client_first_name: new FormControl(""),
    client_last_name: new FormControl(""),
    client_gender: new FormControl(""),
    client_address: new FormControl(""),
    client_address2: new FormControl(""),
    client_city: new FormControl(""),
    client_province: new FormControl(""),
    client_country: new FormControl(""),
    client_postalcode: new FormControl(""),
    client_language: new FormControl(""),
    //submission related
    account_fname: new FormControl(""),
    account_lname: new FormControl(""),
    submission_no: new FormControl(""),
  })

  constructor(
    private tokenStorage: TokenStorageService,
    private activatedRoute: ActivatedRoute,
    private submissions: SubmissionService,
    private clients: ClientService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    const contactUUID = this.tokenStorage.getToken() || "";
    this.client_id = this.activatedRoute.snapshot.params['clientid'];

    this.clients.getClient$(contactUUID, this.client_id).subscribe({
      next: (data: {}) => {
        this.clientInfo = data;
        this.contactTypeList = this.clientInfo.contacts;
        console.log('data', data);

        this.addSubmissionForm.setValue({
          client_first_name: this.clientInfo.client_fname,
          client_last_name: this.clientInfo.client_lname,
          client_gender: this.clientInfo.client_gender,
          client_address: this.clientInfo.client_address,
          client_address2: this.clientInfo.client_address2,
          client_city: this.clientInfo.client_city,
          client_province: this.clientInfo.client_province,
          client_country: this.clientInfo.client_country,
          client_postalcode: this.clientInfo.client_postalcode,
          client_language: this.clientInfo.client_language_id,
          account_fname: this.clientInfo.account_fname,
          account_lname: this.clientInfo.account_lname,
            //submission related
          submission_no: '0-',
        });
      },
      error: (err: any) => {
          console.log("Something went wrong fetching the invoice: ", err)
      }
    });

    flatpickr(".date", {
      altInput: false,
      altFormat: "F j, Y",
      ariaDateFormat: "Y-m-d",
      dateFormat: "Y-m-d"
    });
  }

  openCalendar(e: any): void {
    console.log(e)
  }

  goToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  onSubmit(value: any): void {
    const contactUUID = this.tokenStorage.getToken() || "";
    const account = this.tokenStorage.getUser() || "";
    const clientid = this.activatedRoute.snapshot.params['clientid'];

    console.log("Form values ", value)

    let submissionInfos: any = {
      submission_no: this.addSubmissionForm.get("submission_no")!.value,
      client_id: clientid,
    };

    console.log('submissionInfos ', submissionInfos)

    this.submissions.addSubmission$(contactUUID, submissionInfos).subscribe({
      next: data => {
        console.log("Data --> ", data);
        console.log("Success adding the submission: ", data);   
        this.router.navigate([ '/soumission/'+ data.submission_id + '/editer']);
        this.update_message = "Nouvelle soumission ajoutée avec succèss.";
        this.goToTop();
      },
      error: err => {
        console.log("Something went wrong: ", err)
      }
    });
  }
}
